import axios from "axios";

const token = localStorage.getItem("token")
const instance = axios.create({
    baseURL: 'http://work.digittrix.com/apis/v1/',
});

export const googleAuth = async (body) => {
    try {
        return await instance.post(`auth/google`, body);
    } catch (error) {
        throw error
    }
}